import { Component, OnInit, ViewChild, HostListener, ViewChildren, QueryList } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PerfectScrollbarDirective, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { rotate } from '../theme/utils/app-animation';
import { MenuService } from '../theme/components/menu/menu.service';
import { SharedService } from '../shared/shared.service';
//import { YearService } from '../services/year.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  animations: [ rotate ],
  providers: [ MenuService ]
})
export class PagesComponent implements OnInit { 
  @ViewChild('sidenav') sidenav:any;  
  @ViewChild('backToTop') backToTop:any;  
  @ViewChildren(PerfectScrollbarDirective) pss: QueryList<PerfectScrollbarDirective>;
  public optionsPsConfig: PerfectScrollbarConfigInterface = {};
  public settings:Settings;
  public showSidenav:boolean = false;
  public showInfoContent:boolean = false;
  public toggleSearchBar:boolean = false;
  private defaultMenu:string; //declared for return default menu when window resized 
  public menus = ['vertical', 'horizontal'];
  public menuOption:string;
  public menuTypes = ['default', 'compact', 'mini'];
  public menuTypeOption:string;
  public branches: any;
  public selectedBranch:any;
  public financialYears: any[] = [];
  public selectedYearKey: any;

  constructor(public appSettings:AppSettings, public router:Router, private menuService: MenuService, private sharedService: SharedService){        
    this.settings = this.appSettings.settings;
    this.getBranches();
    this.selectedBranch = +localStorage.getItem("branch");
    console.log('Branch'+this.selectedBranch);

    this.settings = this.appSettings.settings;
  this.getBranches();
  this.selectedBranch = +localStorage.getItem("branch");
  console.log('Branch'+this.selectedBranch)
  }
  
  ngOnInit() {
    this.optionsPsConfig.wheelPropagation = false;
    if(window.innerWidth <= 960){
      this.settings.menu = 'vertical';
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
    }
    this.menuOption = this.settings.menu; 
    this.menuTypeOption = this.settings.menuType; 
    this.defaultMenu = this.settings.menu;

    this.loadFinancialYears();
  }

  

  ngAfterViewInit(){
    setTimeout(() => { this.settings.loadingSpinner = false }, 300); 
    this.backToTop.nativeElement.style.display = 'none'; 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      } 
      if(window.innerWidth <= 960){
        this.sidenav.close(); 
      }                
    });
    if(this.settings.menu == "vertical")
      this.menuService.expandActiveSubMenu(this.menuService.getVerticalMenuItems()); 
  }

  public toggleSidenav(){
    this.sidenav.toggle();
  }

  public chooseMenu(){
    this.settings.menu = this.menuOption; 
    this.defaultMenu = this.menuOption;
    if(this.menuOption == 'horizontal'){
      this.settings.fixedSidenav = false;
    }
    this.router.navigate(['/']); 
  }

  public chooseMenuType(){
    this.settings.menuType = this.menuTypeOption;
  }

  public changeTheme(theme){
    this.settings.theme = theme;       
  }
  
  public closeInfoContent(showInfoContent){
    this.showInfoContent = !showInfoContent;
  }

  @HostListener('window:resize')
  public onWindowResize():void {
    if(window.innerWidth <= 960){
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.settings.menu = 'vertical'
    }
    else{
      (this.defaultMenu == 'horizontal') ? this.settings.menu = 'horizontal' : this.settings.menu = 'vertical'
      this.settings.sidenavIsOpened = true;
      this.settings.sidenavIsPinned = true;
    }
  }

  public onPsScrollY(event){   
    (event.target.scrollTop > 300) ? this.backToTop.nativeElement.style.display = 'flex' : this.backToTop.nativeElement.style.display = 'none';
  }

  public scrollToTop() {
    this.pss.forEach(ps => {
      if(ps.elementRef.nativeElement.id == 'main'){
        ps.scrollToTop(0,250);
      }
    });
  }
  
  public closeSubMenus(){
    if(this.settings.menu == "vertical"){
      this.menuService.closeAllSubMenus();
    }      
  }

  getBranches() {
    if (sessionStorage.getItem("currentUser")) {
      try {
        const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
        if(currentUser?.roles[0] === 'ROLE_ADMIN'){
          this.sharedService.getBranches().subscribe((data: any) => {
            // console.log(data);
            this.branches = data;
            this.selectBranchIfOnlyOne();
          });
        } else {
          this.sharedService.getBranchesByUser().subscribe((data: any) => {
            // console.log(data);
            this.branches = data;
            this.selectBranchIfOnlyOne();
          });
        }
      } catch (error) {}
    }
  }

  onBranchChange(){
    localStorage.setItem("branch", this.selectedBranch);
    this.sharedService.emitBranchChange(this.selectedBranch);
    //this.reLoad();
  }

  private selectBranchIfOnlyOne() {
    if (this.branches?.length === 1) {
      this.selectedBranch = this.branches[0].branchKey;
      this.onBranchChange();
    }
  }

  // reLoad(){
  //   this.router.navigate(['/'])
  // }

  // Added methods for Financial Year loading & selection
// public loadFinancialYears() {
//   this.sharedService.getAllYear().subscribe((data: any[]) => {
//     const allYears = data || [];
//     const currentCompanyKey = localStorage.getItem("branch");

//     // Filter financial years matching the logged-in company key
//     this.financialYears = allYears.filter(fy => 
//       String(fy.companyKey || fy.company_key) === String(currentCompanyKey)
//     );

//     // Fallback if no specific match
//     if (this.financialYears.length === 0) {
//       this.financialYears = allYears;
//     }

//     // Always look for '2026-2027' as the default year on page refresh/load
//     const defaultYear = this.financialYears.find(fy => fy.year === '2026-2027');

//     if (defaultYear) {
//       this.selectedYearKey = defaultYear.yearKey || defaultYear.year_key;
//     } else if (this.financialYears.length > 0) {
//       this.selectedYearKey = this.financialYears[0].yearKey || this.financialYears[0].year_key;
//     }

//     // Automatically save and push the default year to localStorage and interceptor
//     localStorage.setItem("yearKey", String(this.selectedYearKey));
//     if (defaultYear) {
//       localStorage.setItem("year", String(defaultYear.year));
//       localStorage.setItem("minDate", String(defaultYear.minDate || defaultYear.min_date));
//       localStorage.setItem("maxDate", String(defaultYear.maxDate || defaultYear.max_date));
//       localStorage.setItem("companyKey", String(defaultYear.companyKey || defaultYear.company_key));
//     }

//     this.sharedService.emitYearChange(this.selectedYearKey);
//   });
// }


public loadFinancialYears() {
  this.sharedService.getAllYear().subscribe((data: any[]) => {

    const allYears = data || [];

    const currentCompanyKey = localStorage.getItem("branch");

    // Filter financial years by company/branch
    this.financialYears = allYears.filter(fy =>
      String(fy.companyKey || fy.company_key) === String(currentCompanyKey)
    );

    // Fallback if company filtering returns nothing
    if (this.financialYears.length === 0) {
      this.financialYears = allYears;
    }

    if (this.financialYears.length === 0) {
      console.warn('No financial years found');
      return;
    }

    // =====================================================
    // DEFAULT FINANCIAL YEAR = 2026-2027
    // =====================================================

    const defaultYear = this.financialYears.find(
      fy => String(fy.year) === '2026-2027'
    );

    if (defaultYear) {

      this.selectedYearKey =
        defaultYear.yearKey || defaultYear.year_key;

      // Save selected financial year
      localStorage.setItem(
        'yearKey',
        String(this.selectedYearKey)
      );

      localStorage.setItem(
        'year',
        String(defaultYear.year)
      );

      localStorage.setItem(
        'minDate',
        String(defaultYear.minDate || defaultYear.min_date)
      );

      localStorage.setItem(
        'maxDate',
        String(defaultYear.maxDate || defaultYear.max_date)
      );

      localStorage.setItem(
        'companyKey',
        String(defaultYear.companyKey || defaultYear.company_key)
      );

      console.log('Default Financial Year:', defaultYear.year);
      console.log('Default Year Key:', this.selectedYearKey);
      console.log('Min Date:', defaultYear.minDate || defaultYear.min_date);
      console.log('Max Date:', defaultYear.maxDate || defaultYear.max_date);

      // Notify entire application
      this.sharedService.emitYearChange(this.selectedYearKey);

    } else {

      // If 2026-2027 does not exist,
      // select the first available year
      const firstYear = this.financialYears[0];

      this.selectedYearKey =
        firstYear.yearKey || firstYear.year_key;

      localStorage.setItem(
        'yearKey',
        String(this.selectedYearKey)
      );

      localStorage.setItem(
        'year',
        String(firstYear.year)
      );

      localStorage.setItem(
        'minDate',
        String(firstYear.minDate || firstYear.min_date)
      );

      localStorage.setItem(
        'maxDate',
        String(firstYear.maxDate || firstYear.max_date)
      );

      localStorage.setItem(
        'companyKey',
        String(firstYear.companyKey || firstYear.company_key)
      );

      this.sharedService.emitYearChange(this.selectedYearKey);

      console.warn(
        '2026-2027 not found. Selected:',
        firstYear.year
      );
    }
  });
}


// public onYearChange() {
 
//   const selectedFyObj = this.financialYears.find(fy => String(fy.yearKey || fy.year_key) === String(this.selectedYearKey));

//   if (selectedFyObj) {
//     localStorage.setItem("yearKey", String(selectedFyObj.yearKey || selectedFyObj.year_key));
//     localStorage.setItem("year", String(selectedFyObj.year));
//     localStorage.setItem("minDate", String(selectedFyObj.minDate || selectedFyObj.min_date));
//     localStorage.setItem("maxDate", String(selectedFyObj.maxDate || selectedFyObj.max_date));
//     localStorage.setItem("companyKey", String(selectedFyObj.companyKey || selectedFyObj.company_key));
//   }

//   console.log('Year changed to:', this.selectedYearKey);
  
//   // Broadcast change so current page tables can re-fetch data instantly
//   this.sharedService.emitYearChange(this.selectedYearKey);
  
//   // DO NOT call reLoad() or router.navigate here so it never goes to dashboard!
// }

public onYearChange() {

  const selectedFyObj = this.financialYears.find(
    fy =>
      String(fy.yearKey || fy.year_key) ===
      String(this.selectedYearKey)
  );

  if (!selectedFyObj) {
    return;
  }

  const yearKey =
    selectedFyObj.yearKey || selectedFyObj.year_key;

  const minDate =
    selectedFyObj.minDate || selectedFyObj.min_date;

  const maxDate =
    selectedFyObj.maxDate || selectedFyObj.max_date;

  // Save selected financial year
  localStorage.setItem('yearKey', String(yearKey));
  localStorage.setItem('year', String(selectedFyObj.year));
  localStorage.setItem('minDate', String(minDate));
  localStorage.setItem('maxDate', String(maxDate));
  localStorage.setItem(
    'companyKey',
    String(selectedFyObj.companyKey || selectedFyObj.company_key)
  );

  console.log('================================');
  console.log('FINANCIAL YEAR CHANGED');
  console.log('Year:', selectedFyObj.year);
  console.log('Year Key:', yearKey);
  console.log('Min Date:', minDate);
  console.log('Max Date:', maxDate);
  console.log('================================');

  // Notify application
  this.sharedService.emitYearChange(yearKey);

  // Reload CURRENT route only
  // this.router.navigateByUrl(
  //   this.router.url,
  //   { skipLocationChange: true }
  // ).then(() => {
  //   this.router.navigate([this.router.url]);
  // });
}

}